import { BindingSourceEndpoints, DefaultValues, HeadersKeys, HeadersValues, Methods, SourceTypes } from './types';

export const METHODS = [Methods.GET, Methods.POST];
export const SOURCE_TYPES = [SourceTypes.Jdbc, SourceTypes.Api, SourceTypes.Local];
export const DEFAULT_VALUES = [DefaultValues.Now];
export const HEADERS_KEYS = [HeadersKeys.Authorization];
export const HEADERS_VALUES = [HeadersValues.Bearer];
export const API_ENDPOINTS = [BindingSourceEndpoints.ReportUuidFilterId, BindingSourceEndpoints.ReportUuidFilterName];
